/**
 * Single source of truth for Company (parent) and Distributor (child) data.
 * Used by both the CreateNew form and the ParentCode management page.
 */

export const COMPANIES = [
  {
    parentCode: "ABC0001",
    parentName: "Across Insurance Brokers",
    description: "Primary insurance brokerage company",
    status: "active",
  },
  {
    parentCode: "TRV0002",
    parentName: "TravelSure Solutions",
    description: "Travel insurance solutions provider",
    status: "active",
  },
  {
    parentCode: "MOT0003",
    parentName: "MotorShield Corp",
    description: "Motor and auto insurance company",
    status: "active",
  },
  {
    parentCode: "None",
    parentName: "None",
    description: "None",
    status: "",
  },
];

export const DISTRIBUTORS = [
  // ── Across Insurance Brokers (ABC0001) ─────────────────────────────────────
  {
    childCode: "ABC0001-D01",
    childName: "North Delhi Distributor",
    parentCode: "ABC0001",
    description: "",
    status: "active",
  },
  {
    childCode: "ABC0001-D02",
    childName: "South Delhi Distributor",
    parentCode: "ABC0001",
    description: "",
    status: "active",
  },
  {
    childCode: "ABC0001-D03",
    childName: "Mumbai Central Distributor",
    parentCode: "ABC0001",
    description: "",
    status: "active",
  },
  {
    childCode: "ABC0001-D04",
    childName: "Pune Distributor",
    parentCode: "ABC0001",
    description: "",
    status: "active",
  },
  {
    childCode: "ABC0001-D05",
    childName: "Bangalore Distributor",
    parentCode: "ABC0001",
    description: "",
    status: "active",
  },
  {
    childCode: "ABC0001-D06",
    childName: "Chennai Distributor",
    parentCode: "ABC0001",
    description: "",
    status: "active",
  },
  {
    childCode: "ABC0001-D07",
    childName: "Hyderabad Distributor",
    parentCode: "ABC0001",
    description: "",
    status: "active",
  },
  {
    childCode: "ABC0001-D08",
    childName: "Kolkata Distributor",
    parentCode: "ABC0001",
    description: "",
    status: "active",
  },
  {
    childCode: "ABC0001-D09",
    childName: "Ahmedabad Distributor",
    parentCode: "ABC0001",
    description: "",
    status: "active",
  },
  {
    childCode: "ABC0001-D10",
    childName: "Jaipur Distributor",
    parentCode: "ABC0001",
    description: "",
    status: "active",
  },
  {
    childCode: "ABC0001-D11",
    childName: "Lucknow Distributor",
    parentCode: "ABC0001",
    description: "",
    status: "active",
  },
  {
    childCode: "ABC0001-D12",
    childName: "Chandigarh Distributor",
    parentCode: "ABC0001",
    description: "",
    status: "active",
  },
  {
    childCode: "ABC0001-D13",
    childName: "Surat Distributor",
    parentCode: "ABC0001",
    description: "",
    status: "active",
  },
  {
    childCode: "ABC0001-D14",
    childName: "Nagpur Distributor",
    parentCode: "ABC0001",
    description: "",
    status: "active",
  },
  {
    childCode: "ABC0001-D15",
    childName: "Indore Distributor",
    parentCode: "ABC0001",
    description: "",
    status: "active",
  },

  // ── TravelSure Solutions (TRV0002) ─────────────────────────────────────────
  {
    childCode: "TRV0002-D01",
    childName: "Delhi Travel Hub",
    parentCode: "TRV0002",
    description: "",
    status: "active",
  },
  {
    childCode: "TRV0002-D02",
    childName: "Mumbai Travel Hub",
    parentCode: "TRV0002",
    description: "",
    status: "active",
  },
  {
    childCode: "TRV0002-D03",
    childName: "Bangalore Travel Hub",
    parentCode: "TRV0002",
    description: "",
    status: "active",
  },
  {
    childCode: "TRV0002-D04",
    childName: "Chennai Travel Hub",
    parentCode: "TRV0002",
    description: "",
    status: "active",
  },
  {
    childCode: "TRV0002-D05",
    childName: "Hyderabad Travel Hub",
    parentCode: "TRV0002",
    description: "",
    status: "active",
  },
  {
    childCode: "TRV0002-D06",
    childName: "Kolkata Travel Hub",
    parentCode: "TRV0002",
    description: "",
    status: "active",
  },
  {
    childCode: "TRV0002-D07",
    childName: "Pune Travel Hub",
    parentCode: "TRV0002",
    description: "",
    status: "active",
  },
  {
    childCode: "TRV0002-D08",
    childName: "Ahmedabad Travel Hub",
    parentCode: "TRV0002",
    description: "",
    status: "active",
  },
  {
    childCode: "TRV0002-D09",
    childName: "Jaipur Travel Hub",
    parentCode: "TRV0002",
    description: "",
    status: "active",
  },
  {
    childCode: "TRV0002-D10",
    childName: "Goa Travel Hub",
    parentCode: "TRV0002",
    description: "",
    status: "active",
  },
  {
    childCode: "TRV0002-D11",
    childName: "Kochi Travel Hub",
    parentCode: "TRV0002",
    description: "",
    status: "active",
  },
  {
    childCode: "TRV0002-D12",
    childName: "Bhubaneswar Travel Hub",
    parentCode: "TRV0002",
    description: "",
    status: "active",
  },
  {
    childCode: "TRV0002-D13",
    childName: "Patna Travel Hub",
    parentCode: "TRV0002",
    description: "",
    status: "active",
  },
  {
    childCode: "TRV0002-D14",
    childName: "Nagpur Travel Hub",
    parentCode: "TRV0002",
    description: "",
    status: "active",
  },
  {
    childCode: "TRV0002-D15",
    childName: "Vadodara Travel Hub",
    parentCode: "TRV0002",
    description: "",
    status: "active",
  },
  {
    childCode: "TRV0002-D16",
    childName: "Coimbatore Travel Hub",
    parentCode: "TRV0002",
    description: "",
    status: "active",
  },

  // ── MotorShield Corp (MOT0003) ─────────────────────────────────────────────
  {
    childCode: "MOT0003-D01",
    childName: "Delhi Motor Point",
    parentCode: "MOT0003",
    description: "",
    status: "active",
  },
  {
    childCode: "MOT0003-D02",
    childName: "Mumbai Motor Point",
    parentCode: "MOT0003",
    description: "",
    status: "active",
  },
  {
    childCode: "MOT0003-D03",
    childName: "Bangalore Motor Point",
    parentCode: "MOT0003",
    description: "",
    status: "active",
  },
  {
    childCode: "MOT0003-D04",
    childName: "Chennai Motor Point",
    parentCode: "MOT0003",
    description: "",
    status: "active",
  },
  {
    childCode: "MOT0003-D05",
    childName: "Hyderabad Motor Point",
    parentCode: "MOT0003",
    description: "",
    status: "active",
  },
  {
    childCode: "MOT0003-D06",
    childName: "Pune Motor Point",
    parentCode: "MOT0003",
    description: "",
    status: "active",
  },
  {
    childCode: "MOT0003-D07",
    childName: "Kolkata Motor Point",
    parentCode: "MOT0003",
    description: "",
    status: "active",
  },
  {
    childCode: "MOT0003-D08",
    childName: "Ahmedabad Motor Point",
    parentCode: "MOT0003",
    description: "",
    status: "active",
  },
  {
    childCode: "MOT0003-D09",
    childName: "Jaipur Motor Point",
    parentCode: "MOT0003",
    description: "",
    status: "active",
  },
  {
    childCode: "MOT0003-D10",
    childName: "Lucknow Motor Point",
    parentCode: "MOT0003",
    description: "",
    status: "active",
  },
  {
    childCode: "MOT0003-D11",
    childName: "Surat Motor Point",
    parentCode: "MOT0003",
    description: "",
    status: "active",
  },
  {
    childCode: "MOT0003-D12",
    childName: "Chandigarh Motor Point",
    parentCode: "MOT0003",
    description: "",
    status: "active",
  },
  {
    childCode: "MOT0003-D13",
    childName: "Bhopal Motor Point",
    parentCode: "MOT0003",
    description: "",
    status: "active",
  },
  {
    childCode: "MOT0003-D14",
    childName: "Visakhapatnam Motor Point",
    parentCode: "MOT0003",
    description: "",
    status: "active",
  },
  {
    childCode: "MOT0003-D15",
    childName: "Nashik Motor Point",
    parentCode: "MOT0003",
    description: "",
    status: "active",
  },
  {
    childCode: "MOT0003-D16",
    childName: "Rajkot Motor Point",
    parentCode: "MOT0003",
    description: "",
    status: "active",
  },
  {
    childCode: "MOT0003-D17",
    childName: "Madurai Motor Point",
    parentCode: "MOT0003",
    description: "",
    status: "active",
  },
  {
    childCode: "MOT0003-D18",
    childName: "Varanasi Motor Point",
    parentCode: "MOT0003",
    description: "",
    status: "active",
  },
];

/**
 * Map of parentCode → distributor dropdown options.
 * Label format: "{selectedCompanyName} - {distributorName}"
 */
export const PARENT_CHILD_MAP = COMPANIES.reduce((map, company) => {
  map[company.parentCode] = [
    { value: "", label: "Select Distributor" },
    ...DISTRIBUTORS.filter((d) => d.parentCode === company.parentCode).map(
      (d) => ({
        value: d.childCode,
        label: `${company.parentName} - ${d.childName}`,
      }),
    ),
  ];
  return map;
}, {});

/**
 * Company dropdown options.
 * Label format: "CompanyCode(ABC0001) - Name"
 */
export const COMPANY_OPTIONS = [
  { value: "", label: "Select Parent Company Code - Name" },
  ...COMPANIES.map((c) => ({
    value: c.parentCode,
    label: `${c.parentCode} - ${c.parentName}`,
  })),
];
